import {ProfitMessage} from "core/chart/integration/message/profit/ProfitMessage";
import {ProfitMessageType} from "core/chart/integration/message/profit/ProfitMessageType";

export class ProfitPong implements ProfitMessage {

    public type: ProfitMessageType = ProfitMessageType.Pong;
}
